// @ts-check
export class ValidationUtils{
/**
 * 
 * @param {any} main 
 */
constructor(main){
    this.m = this.main = main;
    this.VALIDATION_CLASS=['border','border-danger'];
    this.VALIDATION_EMAIL_MESSAGE = 'Please enter a valid email';
    this.VALIDATION_NUMBER_MESSAGE = 'Please enter a valid number';
    this.VALIDATION_URL_MESSAGE = 'Please enter a valid link';
    this.failed = [];
}

/**
 * 
 * @param {HTMLInputElement[]} els 
 */
async lightValidate(...els){
let isValid = true;
for(let el of els){
if(! el.value){
isValid = false;
this.m.pbu.addClass(el,this.VALIDATION_CLASS);
}else{
this.m.pbu.removeClass(el,this.VALIDATION_CLASS);
}
}
return isValid;
}//func

/**
 * 
 * @param {HTMLInputElement[]} els 
 */
sanitize(els){
let valid = true;
let regex = /script/;
for(let el of els){
//let type = el.type;
let value = el.value;
//note: no value when an input like number has validation message or error
if(el.validationMessage){
//url is quite different
if(el.type!='url'){
this.finalize(el,false,el.validationMessage);
}
}
if(!value){continue;}
if(regex.test(value)){
this.finalize(el,false,'Invalid character');
}
}
valid = this.failed.length==0;
this.failed = [];
return valid;
}//func
/**
 * 
 * @param {HTMLInputElement} el 
 */
required(el){
let valid = true;
//let isText = el.type=='text' || el.type=='password';
if(!el.value){
valid = false;
}
let message = `${el.name?el.name:'This field'} is required`;
this.finalize(el,valid,message);
if(this.main.activeSaveButton){
    this.main.activeSaveButton.disabled = false;
}
return valid;
}//func

/**
 * 
 * @param {HTMLInputElement[]} els 
 */
validate(...els){
let valid = false;
let regex;
let fields = [];
for(let el of els){
if(Array.isArray(el) || el instanceof NodeList){
    fields.push(...el);
}else{
    fields.push(el);
}
}
valid = this.sanitize(fields);
if(!valid){
//check and enable save button to allow form correction
if(this.main.activeSaveButton){
    this.main.activeSaveButton.disabled = false;
}
return false;
}
for(let el of fields){
let type = el.getAttribute('type');
let isRequired = el.classList.contains('sp-validation-required');
let value = el.value;
value?.trim();
switch(type){
    case 'number':
        if(isRequired){
        valid = this.required(el);
        }
            if(value){
                   regex = /^-?\d+(\.\d+)?$/;
                if(!regex.test(value)){
                    valid = false;
                }
                this.finalize(el,valid,this.VALIDATION_EMAIL_MESSAGE);
            }
        
        break;
    case 'tel':
        let errorMessage = '';
        if(isRequired){
        valid = this.required(el);
        }
            if(value){
                let iti = this.main.intlTelInput.getInstance(el);
                if(iti.isValidNumber()){
                    let tel = iti.getNumber();
                    el.setAttribute('data-tel',tel);
                }else{
                    valid = false;
                    let errorCode = iti.getValidationError();
                    switch (errorCode) {
                        case 1://VALIDATION_ERROR.INVALID_COUNTRY_CODE
                            errorMessage = "Please select a valid country code";
                            break;
                        case 2://VALIDATION_ERROR.TOO_SHORT:
                            errorMessage = "This phone number is too short";
                            break;
                        case 3://VALIDATION_ERROR.TOO_LONG:
                            errorMessage = "This phone number is too long";
                            break;
                        case 4:// VALIDATION_ERROR.INVALID_LENGTH:
                            errorMessage = "This phone number has an invalid length";
                            break;
                        default:
                            errorMessage = "Please enter a valid phone number";
                    }
                }
            this.finalize(el,valid,errorMessage);
            }
        
        break;
    case 'email':
        if(isRequired){
           valid = this.required(el);
        }
            if(value){
                regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if(!regex.test(el.value)){
                    valid = false;
                }
            this.finalize(el,valid,this.VALIDATION_EMAIL_MESSAGE);
            }
        
       break;
       case 'url':
        if(isRequired){
            valid = this.required(el);
        }
        if(value){
            let protocol = value.substring(0,value.indexOf(':'));
            if(! protocol){
            value = 'http://' + value;
            }

        try {
            let u = new URL(value);
            valid = u.protocol === "http:" || u.protocol === "https:";
            if(u.hostname!='localhost'){
                let parts= u.hostname.split(".");
            if(parts.length<=1){
                valid = false;
            }else{
                let tld = parts[parts.length - 1];
                valid = tld.length >= 2;
            }
            }
            // if(valid){
            //         el.setAttribute('data-path',u.pathname);
            //         el.setAttribute('data-hostname',u.hostname);
            //     }
        } catch(error) {
            valid = false;
        }
        this.finalize(el,valid,this.VALIDATION_URL_MESSAGE);
        }
        break;
        case 'text':
        default:
        if(isRequired){
            valid = this.required(el);
        }
        break;
}//switch
}//for
valid = this.failed.length==0;
this.failed = [];
return valid;
}//func

/**
 * add or remove validation notice
 * @param {HTMLElement} el 
 * @param {boolean} valid 
 * @param {string} message
 */
finalize(el,valid,message){
if(!valid){
  this.failed.push(false);  
}
let parent = el.closest('div.sp-form-control');
let span = parent.querySelector('.sp-span');
if(valid){
if(span){
        span.remove();
        this.main.pbu.removeClass(el,this.VALIDATION_CLASS);
    }
}else{
    this.main.pbu.addClass(el,this.VALIDATION_CLASS);
    if(span){
        span.textContent = message;
    }else{
        span = this.main.pbu.createElement('span',['sp-span','text-danger'],message);
        parent.appendChild(span);
    }
    
}
}
}//class